import TwoFactorSetup from './twoFactor/PluginSetup.js';
export default {
  install(plg) {
    TwoFactorSetup.install(plg);
  }
};